<template>
  <div>
    <div>
      <div v-if="loaded && adminBanners.length === 0">
        <div class="alert alert-primary" role="alert">
          بنری یافت نشد، برای افزودن بنر
          <router-link
            :to="{ name: 'admin-banners-create' }"
            class="alert-link text-light-primary"
          >
            کلیک
          </router-link>
          کنید
        </div>
      </div>
    </div>

    <div v-if="loaded && adminBanners.length" class="card card-custom gutter-b">
      <div class="card-body">
        <div class="table-responsive">
          <table
            class="table table-head-custom table-head-bg table-borderless table-vertical-center"
          >
            <thead>
              <tr>
                <th>عنوان</th>
                <th>نمایش برای</th>
                <th>عرض</th>
                <th>تاریخ ساخت</th>
                <th>تاریخ بروزرسانی</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="banner in adminBanners" :key="banner.id">
                <td>{{ banner.title }}</td>
                <td>
                  <span v-if="banner.company_id">{{
                    companiesNames[banner.company_id]
                  }}</span>
                  <span v-else>{{ types[banner.type] }}</span>
                </td>
                <td>{{ banner.width }}</td>
                <td>{{ formatDate(banner.created_at) }}</td>
                <td>{{ formatDate(banner.updated_at) }}</td>
                <td class="text-nowrap">
                  <button
                    class="btn btn-xs btn-outline-danger mr-1"
                    @click="destroy(banner.id)"
                  >
                    <i class="flaticon2-trash"></i>
                    حذف
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="overflow-auto mt-5" v-if="adminBannersPagination.lastPage > 1">
      <b-pagination
        v-model="adminBannersPagination.currentPage"
        :total-rows="adminBannersPagination.total"
        :per-page="adminBannersPagination.perPage"
        aria-controls="my-table"
        @input="getBanners()"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import {
  FETCH_ADMIN_BANNERS,
  DESTROY_ADMIN_BANNER
} from "@/core/services/store/admin/banners.module";
import { FETCH_ADMIN_COMPANIES } from "@/core/services/store/admin/users.module.js";
import { mapGetters } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "admin-banners-index",
  data() {
    return {
      loaded: false,
      types: {
        1: "همه",
        2: "کاربران بدون کمپانی",
        3: "کاربران کمپانی‌ها",
        4: "کاربران دارای بخش مالی",
        5: "مدیران"
      }
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "بنر‌‌ها" }]);

    this.$store.dispatch(SET_ACTIONS, {
      links: [
        {
          name: '<i class="flaticon2-plus"></i>افزودن',
          to: { name: "admin-banners-create" },
          class: "btn-primary"
        }
      ]
    });
    this.getBanners();
    this.updateCompanies();
  },
  computed: {
    ...mapGetters(["adminBanners", "adminBannersPagination", "adminCompanies"]),
    companiesNames() {
      let data = {};
      this.adminCompanies.forEach(company => {
        data[company.id] = company.title;
      });

      return data;
    }
  },
  methods: {
    updateCompanies() {
      this.loaded = false;
      this.$store
        .dispatch(FETCH_ADMIN_COMPANIES)
        .then(() => {
          this.loaded = true;
        })
        .catch(() => {
          this.loaded = true;
        });
    },
    getBanners() {
      this.loaded = false;
      this.$store
        .dispatch(FETCH_ADMIN_BANNERS)
        .then(() => {
          this.loaded = true;
        })
        .catch(() => {
          this.loaded = true;
        });
    },
    destroy(id) {
      Swal.fire({
        title: "",
        text: "آیا از حذف بنر‌ اطمینان دارید؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "بله",
        confirmButtonColor: "#4554a0",
        cancelButtonText: "خیر",
        cancelButtonColor: "#ed1c24",
        heightAuto: false
      }).then(result => {
        if (result.isConfirmed) {
          this.$store.dispatch(DESTROY_ADMIN_BANNER, id).then(() => {
            this.getBanners();
          });
        }
      });
    }
  }
};
</script>
